/**
 * Resolve an asset URL returned by the API.
 *
 * The api-server is mounted under `/api` in the monorepo proxy, so
 * user-uploaded images live at `/api/objects/...` and `/api/uploads/...`.
 * Some rows in the database still hold the legacy bare paths
 * (`/objects/...`, `/uploads/...`) from before the routing fix; this
 * helper rewrites them so existing data keeps rendering without a data
 * migration.
 *
 * Absolute URLs (`http(s)://`, `data:`, `blob:`) and falsy inputs are
 * returned unchanged.
 */
export function resolveAssetUrl(
  url: string | null | undefined,
): string | undefined {
  if (!url) return undefined;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  if (url.startsWith("/objects/")) return `/api${url}`;
  if (url.startsWith("/uploads/")) return `/api${url}`;
  return url;
}
